import {
  buildShortUserName,
  buildUserInitialsByEmail,
} from './buildUserName.util';

const _cache = new Map<string, string>();

export function buildFullName(
  firstName?: Nullable<string>,
  lastName?: Nullable<string>,
  middleName?: Nullable<string>,
): string {
  const cacheKey = `${firstName}${lastName}${middleName}`;

  if (_cache.has(cacheKey)) {
    return _cache.get(cacheKey)!;
  }

  const fullName = [lastName, firstName, middleName].filter(Boolean).join(' ');

  _cache.set(cacheKey, fullName);

  return fullName;
}

buildFullName.clearCache = () => _cache.clear();

export function buildInitials(
  firstName?: Nullable<string>,
  lastName?: Nullable<string>,
  email?: Nullable<string>,
): string {
  if (firstName && lastName) {
    return buildShortUserName(firstName, lastName);
  }

  if (firstName) {
    return firstName[0];
  }

  if (lastName) {
    return lastName[0];
  }

  if (email) {
    return buildUserInitialsByEmail(email);
  }

  return '';
}
